import React, { useState } from "react";
import moment from "moment";
import validator from 'validator'

const PassportEditorValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }


  if (!error && !record.countryCode) {
    error = true;
    errorMessage = "Passport 'Country' is required";
  }
  if (!error && !record.passportNumber) {
    error = true;
    errorMessage = "Passport 'Number' is required";
  }
  if (!error && record.countryCode && record.countryCode.length === 2 && record.passportNumber) {
    try {
      if (! validator.isPassportNumber(record.passportNumber,record.countryCode.toUpperCase())) {
        error = true;
        errorMessage = "Passport Number is not valid for country " + record.countryCode;
      }
    } catch (err) {
      console.log(err);
    }
  }
  if (!error && !record.issueDate) {
    error = true;
    errorMessage = "Passport 'Issue Date' is required";
  }
  const issueDate = moment(record.issueDate, "YYYY-MM-DD");
  if (!error && !issueDate.isValid() || issueDate.isAfter(moment())) {
    error = true;
    errorMessage = "Passport 'Issue Date' must be a valid past date";
  }
  if (!error && !record.expiryDate) {
    error = true;
    errorMessage = "Passport 'Expiry Date' is required";
  }
  const expiryDate = moment(record.expiryDate, "YYYY-MM-DD");
  if (!error && !expiryDate.isValid() || expiryDate.isSameOrBefore(issueDate)) {
    error = true;
    errorMessage = "Passport 'Expiry Date' must be after 'Issue Date'";
  }


  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default PassportEditorValidator;
